class FDECaptchaGoogle {

    constructor(publicKey) {
        this.publicKey = publicKey;
        this.codigoRecaptcha = '';
    }

    setup(token) {
        this.codigoRecaptcha = token;
    }

    getPublicKey() {
        return this.publicKey;
    }

    getCodigoRecatpcha() {
        return this.codigoRecaptcha;
    }
}

export default FDECaptchaGoogle;